/**
 * returns current date and time in the formatted way
 */

import { format } from '~/util/date';

const getFlowCreatedDate = () => format(new Date(), 'dd MMM yyyy HH:mm');

export default getFlowCreatedDate;
